import { createSlice } from "@reduxjs/toolkit";

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState: {
    users: [],
  },
  reducers: {
    initializeUser(state, action) {
      state.users.push({ userName: action.payload.userName });
    },
    cacheUser(state, action) {
      let user = state.users.find(
        (x) =>
          x.userName.toLocaleLowerCase() ===
          action.payload.userName.toLocaleLowerCase()
      );
      if (user) {
        user.userName = action.payload.userName;
        user.name = action.payload.name;
        user.avatar = action.payload.avatar;
      }
    },
  },
});

export const userDetailsActions = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
